import Vue, { CreateElement } from 'vue'
import { Component, Inject } from 'vue-property-decorator'
import { Subtitle2 } from '@src/elements/typography/typography'
import EmojiData from '@src/routes/club/emoji/types/EmojiData'
import './index.sass'
import { EmojiType } from '@src/routes/club/emoji/types/EmojiType'
import { Icon } from '@src/elements/icon/icon'
import { MIN_LANDSCAPE_WIDTH } from '@src/util/constants'

@Component(
  {
    computed: {
      emojiData () {
        return this.$store.state.emojiData
      },
      activeType () {
        return this.$store.state.emojiActiveType
      }
    }
  }
)
export class EmojiSelectOption extends Vue {

  @Inject()
  container: { closeDropdown?: () => void }

  private emojiData: EmojiData

  private activeType: string

  updateActiveType (event) {
    const newActiveType = event.target.attributes.data.value
    this.$store.dispatch('updateEmojiActiveType', newActiveType)
    if (newActiveType === EmojiType.DEFAULT && this.container!.closeDropdown) this.container.closeDropdown()
  }

  updateCurrentEmoji (emoji) {
    this.$store.dispatch('updateSelectedEmoji', emoji)
    if (this.container!.closeDropdown && window.innerWidth < MIN_LANDSCAPE_WIDTH) {
      this.container.closeDropdown()
    }
  }

  render (h: CreateElement) {
    let currentEmoji
    if (this.activeType !== EmojiType.DEFAULT) {
      currentEmoji = this.emojiData[this.activeType].selected || this.emojiData[this.activeType].available[0]
    }
    return (
      <div id='emojis-wrapper' slot='default'>
        <div id='emoji-type-wrapper'>
          <div
            class={`emoji-type ${this.activeType === EmojiType.DEFAULT ? 'active' : ''}`}
            onClick={this.updateActiveType}
          >
            <Subtitle2 data={EmojiType.DEFAULT}>{this.$t('PAGE.CLUB.GENERAL_SETTINGS.EMOJIS.DEFAULT_TYPE')}</Subtitle2>
            <div class='underline'/>
          </div>
          <div
            class={`emoji-type ${this.activeType === EmojiType.GLOBAL ? 'active' : ''}`}
            onClick={this.updateActiveType}
          >
            <Subtitle2 data={EmojiType.GLOBAL}>{this.$t('PAGE.CLUB.GENERAL_SETTINGS.EMOJIS.GLOBAL_TYPE')}</Subtitle2>
            <div class='underline'/>
          </div>
          <div
            class={`emoji-type ${this.activeType === EmojiType.JAPAN ? 'active' : ''}`}
            onClick={this.updateActiveType}
          >
            <Subtitle2 data={EmojiType.JAPAN}>{this.$t('PAGE.CLUB.GENERAL_SETTINGS.EMOJIS.JAPANESE_TYPE')}</Subtitle2>
            <div class='underline'/>
          </div>
        </div>

        <div id='emoji-images-wrapper'>
          {this.activeType === EmojiType.DEFAULT && (
            <div class='default-emoji-content'>
              <Icon name='util/default-emoji' />
              <Subtitle2>{this.$t('PAGE.CLUB.GENERAL_SETTINGS.EMOJIS.DEFAULT_TYPE_TITLE')}</Subtitle2>
            </div>
          )}
          {this.activeType !== EmojiType.DEFAULT && this.emojiData[this.activeType].available.length === 0 && (
            <div id='emoji-no-content-wrapper'>
              <Subtitle2>{this.$t('PAGE.CLUB.GENERAL_SETTINGS.EMOJIS.NO_CONTENT')}</Subtitle2>
            </div>
          )}
          {this.activeType !== EmojiType.DEFAULT && this.emojiData[this.activeType].available.length > 0 && (
            <div class='emoji-content'>
              {currentEmoji && (
                <div id='active-emoji-wrapper'>
                  <img key={currentEmoji.url} src={currentEmoji.url} />
                  <Subtitle2>{currentEmoji.name}</Subtitle2>
                </div>
              )}

              <div id='emoji-list-wrapper'>
                {
                  this.emojiData[this.activeType].available.map(
                    (emoji) => (
                      <img
                        src={emoji.url}
                        class='emoji-list-item'
                        onClick={() => this.updateCurrentEmoji(emoji)}
                      />
                    )
                  )
                }
              </div>
            </div>
          )}
        </div>

      </div>
    )
  }

  beforeDestroy () {
    const currentEmoji = this.emojiData[this.activeType].selected || this.emojiData[this.activeType].available[0]
    this.$store.dispatch('updateSelectedEmoji', currentEmoji)
    if (this.container!.closeDropdown && window.innerWidth >= MIN_LANDSCAPE_WIDTH) {
      this.container.closeDropdown()
    }
  }
}
